<template>
  <div>
    <div class="d-flex flex-row flex-nowrap align-center">
      <sf-color-text color="grey"> {{ $t('rma.return') }} </sf-color-text>
      <v-icon color="grey" :icon="mdiCheck" />
    </div>
  </div>
</template>

<script setup lang="ts">
import SfColorText from '@/components/text/SfColorText.vue'
import { mdiCheck } from '@mdi/js'
</script>
